var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['h-100', _vm.skinClasses],attrs:{"id":"app"}},[_c(_vm.layout,{directives:[{name:"show",rawName:"v-show",value:(_vm.i18nLoaded),expression:"i18nLoaded"}],tag:"component"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }